import {LoggedRoute} from './../logged-route'
import {routerV2ElaAssign} from './assign'
import {ElaArticleDebuggerHandler, ElaOverviewHandler, StandardsPageHandler} from './lazy'
import {routerV2ElaPrint} from './print'
import {routerV2ElaReports} from './reports'

export const routerV2Ela = [
  {
    path: '/ela/standards',
    element: <LoggedRoute component={ElaOverviewHandler} />
  },
  {
    path: '/ela/standards/:elaDomainCode/:elaStandardCode',
    element: <LoggedRoute component={StandardsPageHandler} />
  },
  {
    path: '/ela/overview',
    element: <LoggedRoute component={ElaOverviewHandler} />
  },
  {
    path: '/ela-article-debugger',
    element: <LoggedRoute component={ElaArticleDebuggerHandler} />
  },
  ...routerV2ElaAssign,
  ...routerV2ElaReports,
  ...routerV2ElaPrint
]
